import Dialpad from '@mui/icons-material/Dialpad'
import { IconButton } from '@mui/material'
import NumberDialDialog from 'components/Sell/OrderLookup/NumberDialDialog'
import React, { useState } from 'react'

const NumberSearchInput = ({
    onSubmit,
    size,
}: {
    onSubmit: (text: string) => void
    size?: undefined | 'medium'
}) => {
    const [openDial, setOpenDial] = useState(false)
    return (
        <div>
            <IconButton
                sx={{
                    p: 1,
                }}
                onClick={() => setOpenDial(true)}
                size="large"
                color="inherit"
                //prevent open agian when press Enter button
                disabled={openDial}
            >
                <Dialpad
                    sx={{
                        ...(size === 'medium' ? { fontSize: '2rem' } : {}),
                    }}
                />
            </IconButton>
            <NumberDialDialog
                onClose={() => setOpenDial(false)}
                open={openDial}
                onSubmit={(text: string) => {
                    onSubmit(text)
                    setOpenDial(false)
                }}
            />
        </div>
    )
}

export default NumberSearchInput
